import { useReRunBriefAiFitCheck } from "@entities/brief/lib/hooks/ai/useReReunBriefAiFItCheck";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import type { MouseEvent } from "react";

export function useAiMatchAnalyze(
  briefInfluencerId: string,
  updateBriefInfluencer: (id: string, data: IBriefInfluencerV2) => void
) {
  const { reRunBriefAiFitCheck, isReRunning, variables } =
    useReRunBriefAiFitCheck(updateBriefInfluencer);

  const isAnalyzing = isReRunning && variables === briefInfluencerId;

  const handleAnalyze = (event?: MouseEvent) => {
    event?.stopPropagation();
    reRunBriefAiFitCheck(briefInfluencerId);
  };

  return { handleAnalyze, isAnalyzing };
}
